import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryKeys } from '@/api/apiConfig';
import { PriceRequest, PriceResponse, ProblemDetails, ProductVariantId } from '@/generated/data.schemas';
import { getPrices } from '@/generated/price';

// fetch prices from DIH
const fetchPrices = async (segmentationId: number, priceRequest: PriceRequest): Promise<PriceResponse[]> => {
	const response = await getPrices(segmentationId, priceRequest);
	return response.data;
};

export const usePricesQuery = (
	segmentationId: number,
	lines: ProductVariantId[],
	isActive: boolean,
): UseQueryResult<PriceResponse[] | null | undefined, undefined | ProblemDetails> => {
	// hardcode until used
	const skipCache = false;

	return useQuery({
		queryKey: queryKeys.prices.all(segmentationId, { lines, skipCache }).queryKey,
		queryFn: () => fetchPrices(segmentationId, { lines, skipCache }),
		enabled: isActive && lines.length > 0,
		retry: false,
	});
};
